import PropTypes from 'prop-types';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

// project import
import Loader from 'components/Loader';
import { SimpleLayoutType } from 'config';

//const Header = lazy(() => import('./Header'));

// ==============================|| LAYOUT - SIMPLE / LANDING ||============================== //

const SimpleLayout = ({ layout = SimpleLayoutType.SIMPLE }) => {
  // Check if in development mode to add top padding for warning bar
  const isProduction = (process.env.REACT_APP_PRODUCTION || '').toUpperCase() === 'TRUE';

  return (
    <Suspense fallback={<Loader />}>
      <Box sx={{ paddingTop: isProduction ? 0 : '20px' }}>
        <Outlet />
      </Box>
    </Suspense>
  );
};

SimpleLayout.propTypes = {
  layout: PropTypes.string
};

export default SimpleLayout;
